import { createContext, useContext, PropsWithChildren } from 'react';
import { useQuery, useQueryClient } from 'react-query';
import { getIntegrations } from '../core/api';
import { AmazonIntegration } from '../core/types';
import { useAppSelector } from '../hooks';

const IntegrationsContext = createContext<{
  refetchIntegrations: () => void;
  isLoading: boolean;
  integrations: AmazonIntegration[] | undefined;
}>({
  refetchIntegrations: () => {},
  isLoading: false,
  integrations: [],
});

export function IntegrationsProvider({ children }: PropsWithChildren<{}>) {
  const queryClient = useQueryClient();
  const user = useAppSelector((s) => s.user.user);
  const activeCompanyId = useAppSelector(
    (s) => s.user.activeCompany?.company_id
  );

  const { data, isLoading } = useQuery(
    ['SellerIntegrations', user?.Id, activeCompanyId],
    () => getIntegrations(activeCompanyId)
  );

  const refetchIntegrations = () => {
    queryClient.invalidateQueries([
      'SellerIntegrations',
      user?.Id,
      activeCompanyId,
    ]);
  };

  return (
    <IntegrationsContext.Provider
      value={{
        refetchIntegrations,
        isLoading,
        integrations: data || [],
      }}
    >
      {children}
    </IntegrationsContext.Provider>
  );
}

export function useSellerIntegrations() {
  return useContext(IntegrationsContext);
}
